<div id="content-desktop">
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-12">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
          NonBankATMSurchargeSettlement.com

          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(866) 893-1052
        </span>
      </div>
    </div>
  </div>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #8BC34A; width: 100%; ">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_black" [routerLink]="['/']" style="color: black; font-weight: bold ">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/faqs']" style="color: black; font-weight: bold">FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_black" [routerLink]="['/notice']" style="color: black; font-weight: bold ">Notice</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_black" [routerLink]="['/claim-form']" style="color: black; font-weight: bold ">Claim Form</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/file']" style="color: black; font-weight: bold">File Your Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/court-documents']" style="color: black; font-weight: bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/important-dates']" style="color: black; font-weight: bold">Important Dates</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/contact']" style="color: black; font-weight: bold">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
<div id="content-mobile">
  <div class="container">
    <br />
    <div class="row">
      <div class="col-md-12">
        <span style="padding-top: 3%; font-size: 1.6em; font-weight: 700">
          NonBankATMSurchargeSettlement.com<br/>
          (866) 893-1052
        </span>
      </div>
    </div>
  </div>
  <nav class="navbar navbar-expand-sm navbar-toggleable-sm navbar-light  border-bottom " style="background-color: #8BC34A; width: 100%; ">
    <div class="container">
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target=".navbar-collapse" aria-label="Toggle navigation" [attr.aria-expanded]="isExpanded" (click)="toggle()">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse collapse d-sm-inline-flex flex-sm-row-reverse justify-content-center" [ngClass]="{ show: isExpanded }">
        <ul class="navbar-nav flex-grow">
          <li class="nav-item" [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
            <a class="nav-link  hover_black" [routerLink]="['/']" style="color: black; font-weight: bold ">Home</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/faqs']" style="color: black; font-weight: bold">FAQs</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_black" [routerLink]="['/notice']" style="color: black; font-weight: bold ">Notice</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link  hover_black" [routerLink]="['/claim-form']" style="color: black; font-weight: bold ">Claim Form</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/file']" style="color: black; font-weight: bold">File Your Claim</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/court-documents']" style="color: black; font-weight: bold">Court Documents</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/important-dates']" style="color: black; font-weight: bold">Important Dates</a>
          </li>
          <li class="nav-item" [routerLinkActive]="['link-active']">
            <a class="nav-link hover_black" [routerLink]="['/contact']" style="color: black; font-weight: bold">Contact</a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</div>
